import { Box, Card, styled, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessagesDeProducteurs } from '../../models/MessagesDeProducteurs';
import { Producteurs } from '../../models/Producteurs';
import { StyledRowBox } from '../../theme/StyledElements';
import { getImageKitUrlFrom } from '../../utils';

const StyledMessageCard = styled(Card)(() => ({
    width: '425px',
    backgroundColor: '#F4EAD7',
    borderRadius: '70px',
    border: '3px solid #134C03',
    padding: '10px'
}));

const StyledMessageImg = styled('img')(() => ({
    height: '80px',
    width: '80px',
    marginRight: '20px',
    borderRadius: '50%',
    objectFit: 'cover'
}));

const StyledDescriptionTypography = styled(Typography)(() => ({
    whiteSpace: 'nowrap',
    width: '270px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: '20px'
}));

interface MessageDescriptionComponentProps {
    messageData: MessagesDeProducteurs;
    user: Producteurs | null;
}

export function MessageDescriptionComponent({
    messageData,
    user
}: MessageDescriptionComponentProps): JSX.Element {
    return (
        <StyledMessageCard>
            <StyledRowBox>
                {messageData?.photos && typeof messageData?.photos[0] === 'string' && (
                    <StyledMessageImg src={getImageKitUrlFrom(messageData?.photos[0])} />
                )}
                <Box>
                    <Typography variant="subtitle2" color="#E37F1E" sx={{ marginTop: '10px' }}>
                        {user && user.nomFerme}
                    </Typography>
                    <StyledDescriptionTypography variant="subtitle1" color="#134C03">
                        {messageData.description}
                    </StyledDescriptionTypography>
                </Box>
            </StyledRowBox>
        </StyledMessageCard>
    );
}
